import { pxToRem } from "@/util/common";
import { Swiper, Image } from "antd-mobile";
import { createUseStyles } from "react-jss";
import { gameColumns, GameItem } from "../type";
import useCustomTranslation from "@/hooks/useTranslation";
import i18n, { translateLanguage } from "@/locales";

const EvoColumn: React.FC<{
	data: gameColumns;
	onClick: (game: GameItem) => void;
	onMore: () => void;
}> = ({ data, onClick, onMore }) => {
	const { t } = useCustomTranslation();
	const classes = useStyles();

	return (
		<div className={classes.gameWrap}>
			<div className={classes.columnTitle}>
				<div className="l">
					<Image
						className="i"
						src={data.logo}
						fit="cover"
						placeholder={
							<Image
								className="i"
								src={require("@/assets/images/sideBar/liveCasino.png")}
								fit="cover"
							/>
						}
					/>
					<strong>
						{translateLanguage(
							data.categoryOtherDesc,
							i18n.language
						)}
					</strong>
				</div>
				<div onClick={onMore} className="more">
					{t("ViewAll")} {">>"}
				</div>
			</div>
			<div className="main">
				<Swiper
					stuckAtBoundary={false}
					slideSize={33}
					indicator={() => null}
					loop
				>
					{data.gameVOList.map((game, index) => (
						<Swiper.Item key={index} onClick={() => onClick(game)}>
							<div className={classes.gameSingle}>
								<Image
									className="img"
									src={game.coverPic}
									fit="cover"
								/>
								<div className="cont">
									<div className="name">
										{translateLanguage(
											game.otherName ?? "",
											i18n.language
										)}
									</div>
									<div className="play">
										{game.gameCompany.toLocaleUpperCase()}
									</div>
								</div>
							</div>
						</Swiper.Item>
					))}
				</Swiper>
			</div>
		</div>
	);
};

export default EvoColumn;

const useStyles = createUseStyles({
	gameWrap: {
		padding: {
			left: pxToRem(20),
		},

		"& .main": {
			position: "relative",
			"&:after": {
				content: '""',
				position: "absolute",
				width: pxToRem(74),
				top: 0,
				bottom: 0,
				right: 0,
				background:
					"linear-gradient(90deg, rgba(30, 33, 42, 0) 0%, #1E212A 100%)",
			},
		},
	},
	columnTitle: {
		display: "flex",
		justifyContent: "space-between",
		padding: {
			right: pxToRem(20),
			top: pxToRem(12),
			bottom: pxToRem(12),
		},
		"& .l": {
			flex: 1,
			overflow: "hidden",
			display: "flex",
			alignItems: "center",
			"& .i": {
				width: pxToRem(24),
				height: pxToRem(24),
				marginRight: pxToRem(8),
			},
			"& strong": {
				color: "#FFFFFF",
				fontFamily: "Noto Sans SC",
				fontSize: pxToRem(16),
				fontWeight: 700,
			},
		},
		"& .more": {
			color: "#868FA8",
			fontSize: pxToRem(14),
			fontWeight: 400,
		},
	},
	gameSingle: {
		paddingRight: pxToRem(15),
		"& .img": {
			height: pxToRem(115),
			borderRadius: pxToRem(10),
			border: "1px solid #384F7A",
		},
		"& .cont": {
			paddingTop: pxToRem(10),
		},
		"& .name": {
			color: "#FFFFFF",
			fontSize: pxToRem(14),
			fontWeight: 500,
			overflow: "hidden",
			textOverflow: "ellipsis",
			whiteSpace: "nowrap",
		},
		"& .play": {
			color: "#868FA8",
			fontSize: pxToRem(12),
			fontWeight: 400,
			overflow: "hidden",
			textOverflow: "ellipsis",
			whiteSpace: "nowrap",
		},
	},
});
